export default class BaseControllerManager {
  constructor(ViewControllers) {
    this._VC = ViewControllers
    this._controllers = []
  }

  add(ID = null, content) {
    if (typeof ID === 'string' && ID === 'null') ID = null
    this._controllers.unshift(this.getController(ID, content))
  }

  pop() {
    this._controllers.pop()
  }

  shift() {
    this._controllers.shift()
  }

  use(type) {
    if ('prev' === type) return this._controllers[1]
    if ('current' === type) return this._controllers[0]

    return false
  }

  getController(ID = null, content = null) {
    let controller

    if (ID !== null && isSet(this._VC[ID])) {
      controller = new this._VC[ID](content)
    } else if (content !== null && isSet(this._VC[content.getAttribute('id')])) {
      controller = new this._VC[content.getAttribute('id')](content)
    } else {
      controller = new this._VC['default'](content)
    }

    return controller
  }
}
